import React, { useState, useEffect } from 'react';
import {Project} from './Project'
import axios from "axios";

export const ProjectHandler=(props)=>{
    const [myData, setMyData] = useState([])
    const [loading, setLoading] = useState(false)
    var option = {
      method: 'GET',
      url: 'https://karlson.herokuapp.com/projects'
    };
    useEffect(()=>{
      setLoading(true)
      axios
      .request(option)
      .then(function(response) {
        let data = JSON.stringify(response.data.data)
        setMyData(JSON.parse(data))
        console.log("Succesfully fetched all posts!")
      })
      .catch(function(err) {
        console.log(err);
      })
      .finally(()=>{
        setLoading(false)
      })     
    }, [])
    
    if (loading) return <div className="loader"><span className="load"></span><span className="load"></span><span className="load"></span></div>;

    return (
        <div className="container text-start">
        <br/>
        <h1>My Projects:</h1><hr/>
       	{myData.slice(0).reverse().map((post)=>{
             return <Project key = {post.sno} mypost = {post}/>
         })}
         </div>
 )}   